import { Auth } from "aws-amplify";

class AuthService {
    static isAuthenticated;

    static isLoggedInCached() {
        return this.isAuthenticated;
    }
    static async isLoggedIn () {
        try {
            await Auth.currentAuthenticatedUser();
            this.isAuthenticated = true;
        } catch(e) {
            this.isAuthenticated = false;
        }
        return this.isAuthenticated;
    };

    static async logout() {
        this.isAuthenticated = false;
        return await Auth.signOut({global: true});
    }
}

export default AuthService;